import { useMemo, useRef, useEffect } from "react";
import { DisplayState } from "../components/results";

type AnimationConfig = {
  mode: "sync" | "wait";
  transition?: {
    duration: number;
    ease: string;
  };
};

export function useAnimationMode(currentState: DisplayState): AnimationConfig {
  const previousState = useRef<DisplayState>(DisplayState.Suggestions);

  // Update the previous state after the current render
  useEffect(() => {
    previousState.current = currentState;
  }, [currentState]);

  return useMemo(() => {
    // If we're transitioning from results to suggestions, wait for exit
    if (previousState.current === DisplayState.Results && currentState === DisplayState.Suggestions) {
      return {
        mode: "wait",
        transition: {
          duration: 0.15, // Faster exit animation when waiting
          ease: "easeOut",
        },
      };
    }

    // For all other transitions, animate concurrently
    return {
      mode: "sync",
    };
  }, [currentState]);
}
